module.exports = __webpack_public_path__ + "img/1.4c05a2b8.png";